import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from '../../assets/css/template.module.css';
import banner from '../../assets/css/banner.module.css'
import stylesMain from '../../assets/css/main.module.css';
import stylesContexto from '../../assets/css/contexto.module.css';

import dataJson from '../../data/json/template.json';
import dataRedirect from '../../data/json/modalRedirect.json';

import Celular from '../Celular';
import { BsChevronDoubleDown } from 'react-icons/bs';
import { PiBagSimple } from "react-icons/pi";
import { RiWhatsappLine, RiUserLine } from "react-icons/ri";

import Formulario from '../Formulario';

import imgCasa from '../../assets/imagens/webp/casas-de-luxo.webp';
import imgMansao from '../../assets/imagens/webp/mansao-de-luxo.webp';
import logo from '../../assets/imagens/svg/logo.svg';

import imgMob from "../../assets/imagens/webp/corretor-de-imovel-mob.webp";
import imgDesk from "../../assets/imagens/webp/corretor-de-imovel-desktop.webp";

import Footer from '../Footer';
import { Modal, Input, Typography, Space } from 'antd';
import { toast } from 'react-toastify';

const { Title, Text } = Typography;

const TemplatePage = () => {
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const location = useLocation();

    const detailsRef = useRef(null);
    const celularRef = useRef(null);
    const formularioRef = useRef(null);
    const bubbleRef = useRef(null);

    const [isMostrarSectionCelular, setIsMostrarSectionCelular] = useState(false);
    const [ancoraFormulario, setAncoraFormulario] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [userName, setUserName] = useState('');
    const [isRedirecting, setIsRedirecting] = useState(false);
    const [modalType, setModalType] = useState('default');

    // 1. Carrega pageData uma única vez
    useEffect(() => {
        setPageData(dataJson.page);
    }, []);

    // 2. Lê a URL e seta a opção — só roda quando pageData já existe
    useEffect(() => {
        if (!pageData) return;

        // Pega a última parte da URL: "abrir-empresa"
        const pathParts = location.pathname.split('/');
        const lastPart = pathParts[pathParts.length - 1];

        // Busca no JSON qual opção tem essa url_section
        const optionFromUrl = pageData.options.find(opt =>
            opt.url_section === lastPart || opt.id === lastPart
        );

        if (optionFromUrl) {
            setSelectedOption(optionFromUrl);
            setIsMostrarSectionCelular(true); // <--- Isso garante que a seção do celular apareça
        } else {
            // Se estiver apenas em "/corretor", reseta
            setSelectedOption(null);
            setIsMostrarSectionCelular(false);
        }
    }, [location.pathname, pageData]); // Adicionei .pathname aqui para ser mais específico

    // 3. Scroll até a seção de detalhes
    useEffect(() => {
        if (selectedOption) {
            const timer = setTimeout(() => {
                if (detailsRef.current) {
                    detailsRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }, 300); // 300ms dá tempo do React renderizar a seção nova
            return () => clearTimeout(timer);
        }
    }, [selectedOption]);

    // 4. Scroll até formulário
    useEffect(() => {
        if (ancoraFormulario && formularioRef.current) {
            formularioRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setAncoraFormulario(false);
        }
    }, [ancoraFormulario]);

    // 5. Modal automático após 30s
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsModalVisible((prevVisible) => {
                if (!prevVisible) {
                    setModalType('custom');
                    return true;
                }
                return prevVisible;
            });
        }, 30000);
        return () => clearTimeout(timer);
    }, []);

    // 6. Bolha de chat após 18s
    useEffect(() => {
        const timer = setTimeout(() => {
            if (bubbleRef.current) {
                bubbleRef.current.classList.add(styles['show-text']);
            }
        }, 18000);
        return () => clearTimeout(timer);
    }, []);

    // 7. Escuta mensagem do iframe para fechar modal
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data === 'close_whatsapp_modal') {
                setIsModalVisible(false);
                setIsRedirecting(false);
                setUserName('');
                setModalType('default');
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    if (!pageData) return null;

    const executarScrollCelular = () => {
        setTimeout(() => {
            if (celularRef.current) {
                celularRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }, 100);
    };

    const handleVoltar = () => {
        // 1. Limpa os estados para esconder as seções imediatamente
        setSelectedOption(null);
        setIsMostrarSectionCelular(false);

        // 2. Atualiza a URL para a rota pai (sem o parâmetro da seção)
        navigate('/corretor');

        // Opcional: Scroll para o topo para o usuário ver o banner de novo
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const showModal = (e) => {
        e.preventDefault();
        setModalType('default');
        setIsModalVisible(true);
    };

    const handleOk = () => {
        const nomeLimpo = userName.trim();
        if (!nomeLimpo) {
            toast.info("Por favor, digite seu nome.");
            return;
        }
        setIsRedirecting(true);
    };

    const getBgImage = (id) => {
        if (id === "abrir" || id === "migrar") return `url(${imgCasa})`;
        if (id === "trocar") return `url(${imgMansao})`;
        return null;
    };

    return (
        <main className={styles['main-wrapper']}>

            {/* BANNER RESPONSIVO */}
            <section className={banner['hero-section']} style={{
                '--bg-image-desktop': `url(${imgDesk})`,
                '--bg-image-mobile': `url(${imgMob})`
            }}>
                <div className={banner['overlay']}></div>

                <div className={banner['container']}>
                    <div className={banner['content-wrapper']}>
                        <img src={logo} alt="Company Logo" className={banner['logo-style']} />
                        <h1 className={banner['title']}>
                            <span style={{ color: "#C5A059" }}>{pageData.title}</span> <br /> {pageData.subtitle}
                        </h1>
                        <p className={banner['description']}>
                            {pageData.description}
                        </p>
                    </div>

                    <div className={banner['cards-container']}>
                        {pageData.options.map((opt) => (
                            // Link usa url_section — gera /#/corretor/abrir-empresa etc.
                            <Link style={{textDecoration: "none"}} to={`${pageData.url}/${opt.url_section}`} key={opt.id}>
                                <div className={banner['card']} onClick={() => setSelectedOption(opt)}>
                                    <div className={banner['icon-wrapper']}>
                                        <PiBagSimple />
                                    </div>
                                    <div className={banner['card-content']}>
                                        <h3>{opt.title}</h3>
                                        <span>{opt.desc}</span>
                                    </div>
                                    <div style={{ width: 40, height: 40, margin: "0 auto", position: "relative", top: "-20px" }}>
                                        <div className={stylesContexto['botao-pulsante']}><BsChevronDoubleDown /></div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* SEÇÃO 2: DETALHES — ref aqui é o alvo do scroll */}
            {selectedOption && (
                <section
                    ref={detailsRef}
                    className={stylesContexto['details-full-section']}
                    style={{ '--bg-image': getBgImage(selectedOption.id) }}
                >
                    <div className={stylesContexto['content-section']}>
                        <div className={stylesContexto['detail-content']}>
                            <div>
                                <div
                                    onClick={handleVoltar}
                                    className={stylesContexto['status-tag']}
                                    style={{ cursor: "pointer" }}
                                >
                                    ← Voltar
                                </div>
                                <h2 className={stylesContexto['detail-title']}>
                                    {selectedOption.title_section.split("gratuitas").map((part, index, arr) => (
                                        <React.Fragment key={index}>
                                            {part}
                                            {index < arr.length - 1 && (
                                                <span style={{ color: "rgb(197, 160, 89)" }}>gratuitas</span>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </h2>

                                <div style={{ display: "block" }}>
                                    <p>{selectedOption.apartir}</p>
                                    <div style={{ marginBottom: 25 }}>
                                        <label className={styles['pricy']}>{selectedOption.valor}</label>
                                    </div>
                                </div>

                                <div className={styles['flex']}>
                                    <button className={styles['btn-primary']} onClick={() => setAncoraFormulario(true)}>
                                        {selectedOption.descript_btn} <PiBagSimple style={{ fontSize: 25 }} />
                                    </button>
                                </div>
                            </div>

                            <div className={stylesContexto['visual-box']}>
                                <div className={stylesContexto['visual-title']}>
                                    <label>Ideal para...</label>
                                </div>
                                <ul>
                                    {selectedOption?.lista?.map((opcao, index) => (
                                        <li key={opcao.id} className={stylesContexto['lista-item']}>
                                            <span className={stylesContexto['lista-numero']}>{index + 1}</span>
                                            <span className={stylesContexto['lista-texto']}>{opcao.description}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsMostrarSectionCelular(true);
                            executarScrollCelular();
                        }}
                        className={stylesContexto['botao-pulsante']}
                        style={{ zIndex: 10, position: 'relative' }}
                    >
                        <BsChevronDoubleDown />
                    </div>
                </section>
            )}

            {/* SEÇÃO 3: CELULAR */}
            {isMostrarSectionCelular && (
                <section
                    ref={celularRef}
                    className={stylesMain['section-container']}
                    style={{ paddingTop: '50px' }}
                >
                    <div className={styles['center-title']}>
                        <h4>
                            <label style={{ color: "rgb(197, 160, 89)" }}>TUDO EM UM SÓ LUGAR </label>
                            <br /> guias e notas fiscais na palma da sua mão
                        </h4>
                    </div>
                    <Celular
                        selectedOption={selectedOption}
                        setAncoraFormulario={setAncoraFormulario}
                        pageData={pageData}
                        showModal={showModal}
                    />
                </section>
            )}

            {selectedOption && (
                <div className={styles['flex-block']} style={{ background: "rgb(21, 27, 35)" }}>
                    <div className={styles['flex']} style={{ padding: 10 }}>
                        <button className={styles['btn-primary']} onClick={() => setAncoraFormulario(true)}>
                            {selectedOption.descript_btn} <PiBagSimple style={{ fontSize: 25 }} />
                        </button>
                    </div>
                </div>
            )}

            {selectedOption && (
                <>
                    <svg
                        viewBox="0 0 1440 320"
                        preserveAspectRatio="none"
                        style={{ display: 'block', width: '100%', height: '180px', background: "#fff" }}
                    >
                        <path
                            fill="rgb(21, 27, 35)"
                            fillOpacity="1"
                            d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,128C672,107,768,117,864,149.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
                        />
                    </svg>

                    <div ref={formularioRef} style={{ background: "#fff" }}>
                        <section className={`${stylesMain['form-container']}`}>
                            <Formulario selectedOption={selectedOption} />
                        </section>
                    </div>
                </>
            )}

            {/* BOTÃO WHATSAPP FIXO */}
            <div className={styles['btn-whatsap-fixed']} id="btn-wts" onClick={showModal} style={{ color: "#fff" }}>
                <RiWhatsappLine />
                <div className={styles['chat-bubble']} ref={bubbleRef}>
                    <div className={styles['typing']}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div className={styles['chat-text']}>
                        Está com dúvida?
                    </div>
                </div>
            </div>

            <Footer />

            <Modal
                open={isModalVisible}
                onOk={handleOk}
                onCancel={() => {
                    setIsModalVisible(false);
                    setIsRedirecting(false);
                    setUserName('');
                    setModalType('default');
                }}
                okText={
                    isRedirecting
                        ? "Redirecionando..."
                        : modalType === 'custom'
                            ? "Quero falar com um contador agora"
                            : dataRedirect.page?.btn || "Ir para WhatsApp"
                }
                centered
                okButtonProps={{
                    style: {
                        backgroundColor: '#25d366',
                        borderColor: '#25d366',
                        fontWeight: '600',
                        display: isRedirecting ? 'none' : 'inline-block'
                    }
                }}
                title={
                    <Space>
                        <RiWhatsappLine style={{ color: '#25d366', fontSize: 24 }} />
                        <span>
                            {modalType === 'custom'
                                ? "Falar com um contador"
                                : dataRedirect.page?.title || "Falar com um consultor"}
                        </span>
                    </Space>
                }
                width={600}
            >
                <div style={{ textAlign: 'center', padding: '10px 0' }}>
                    {!isRedirecting ? (
                        modalType === 'custom' ? (
                            <>
                                <Title level={4} style={{ color: '#ff4d4f' }}>
                                    Ainda processando as informações ou a burocracia te travou?
                                </Title>
                                <Text>
                                    Simplificamos a contabilidade da sua empresa para você focar no que importa: vender.
                                </Text>
                            </>
                        ) : (
                            <>
                                <Title level={4} style={{ color: '#C5A059', marginBottom: 8 }}>
                                    {dataRedirect.page?.description}
                                </Title>
                                <Text strong style={{ display: 'block', fontSize: '16px', marginBottom: 16 }}>
                                    {dataRedirect.page?.text}
                                </Text>
                            </>
                        )
                    ) : (
                        <div style={{ width: '100%', height: '300px' }}>
                            <iframe
                                id="id-redirect"
                                className="class-redirect"
                                key={userName}
                                src={`./indexRedirect.html?nome=${encodeURIComponent(userName)}&tipo=${selectedOption?.id}`}
                                title="Tracking Redirect"
                                sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox allow-top-navigation"
                                style={{ width: '100%', height: '100%', border: 'none' }}
                            />
                        </div>
                    )}

                    {!isRedirecting && (
                        <Input
                            size="large"
                            placeholder="Como podemos te chamar?"
                            prefix={<RiUserLine style={{ color: '#bfbfbf' }} />}
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            onPressEnter={handleOk}
                            style={{ borderRadius: '8px', marginBottom: 16, marginTop: 20 }}
                        />
                    )}
                </div>
            </Modal>

        </main>
    );
};

export default TemplatePage;